import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithQueryParams } from "@utils/http-util";
import { QueryParameter } from "@idw-types/common";
import { VerificationTransactionDetails } from "@idw-types/data/verification-transaction-details";
import { injectTransactionId } from "@utils/parameter-injector";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";

export const getVerificationTransactionDetailsRequest = async (
    transactionId: string,
    timeZone: string,
): Promise<GenericNetworkResponse<VerificationTransactionDetails>> => {
    const route = injectTransactionId(apiRoutes.reports.verificationTransaction.transactionWithId, transactionId);
    const queryParameters: Array<QueryParameter> = [];

    if (timeZone) {
        queryParameters.push({ parameter: "timeZone", value: timeZone });
    }

    const { data, error }: { data?: VerificationTransactionDetails, error?: any } = await handleRequestWithQueryParams(RequestTypes.GET, route, queryParameters);
    return { data, error };
};